import { z } from "zod";
import "../zod-runtime.js";
import { workflowStatusSchema } from "./enums.js";
import { calloutSchema } from "./geometry.js";
export const mapSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    status: workflowStatusSchema,
    availability: z.enum(["active", "setup_required"]),
    radarPath: z.string().nullable(),
    coordinateSystem: z.literal("normalized-1000"),
    revision: z.string(),
    callouts: z.record(z.string(), calloutSchema),
    version: z.number().int().positive().default(1),
});
